import React, { ComponentProps } from 'react';
import { Flex, Square } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

type FlexProps = ComponentProps<typeof Flex>;

export type DataTableFooterProps = Partial<Pick<FlexProps, 'justifyContent'>>;

export const DataTableFooter: React.FC<DataTableFooterProps> = ({
  children,
  justifyContent = 'flex-end',
}) => {
  const { isError, isEmpty } = useDataTableContext();

  if (isError || isEmpty) {
    return null;
  }

  return (
    <Square
      as="footer"
      inset="md"
      bg="tintedBackground"
      borderTop="1px solid"
      borderColor="lightLine"
      borderBottomLeftRadius="4px"
      borderBottomRightRadius="4px"
    >
      <Flex justifyContent={justifyContent} alignItems="center">
        {children}
      </Flex>
    </Square>
  );
};
